import React, { useState } from 'react';
import './App.css';
import logo from './assets/logo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import Spinner from 'react-bootstrap/Spinner';
import { Button, Modal } from 'react-bootstrap';
import coinData  from './coin.json';

function App() {
  const [question, setQuestion] = useState("");
  const [response, setResponse] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [buttonsDisabled, setButtonsDisabled] = useState(false);
  const [showSuggestions, setShowSuggestions] = useState(true);
  const [suggestions, setSuggestions] = useState([]);
  
  const [showModal, setShowModal] = useState(false);  // State to manage modal visibility
  
  const BaseUrl = process.env.REACT_APP_BASE_URL;

  // Function to toggle modal visibility
  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  const printStringByLetter = (text, myDiv_id) => {
    const myDiv = document.getElementById(myDiv_id);
    myDiv.style.display = "block";
    myDiv.style.textAlign = "left";
    let index = 0;
    let lastChar = ''; 
    myDiv.innerHTML = ""; 
    const intervalId = setInterval(() => {
      let char = text.charAt(index);
      let nextChar = text.charAt(index + 1);
      if (char === '.' && !isNaN(parseInt(lastChar)) && !isNaN(parseInt(nextChar))) {
        myDiv.innerHTML += char;
      } else if (char === '.' || char === ':' || char === '!' || char === '?' ) {
        myDiv.innerHTML += char + "<br> <br>"; 
      } else if (char === ' ') {
        if (lastChar !== ' ') {
          myDiv.innerHTML += char;
        }
      } else {
        myDiv.innerHTML += char;
      }
      lastChar = char;
      index++;
      if (index === text.length) {
        clearInterval(intervalId);
        setButtonsDisabled(false);
      }
    }, 10);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const symbol = coinData[question.charAt(0).toUpperCase() + question.slice(1).toLowerCase()];
    setButtonsDisabled(true); 
    setLoading(true);
    if (!symbol) {
      setLoading(false);
      printStringByLetter("Sorry, this system only allows searches related to cryptocurrencies and tokens.", "my_chatgpt_style_div_1");
      return;
    }
    try {
        const res = await axios.post(`${BaseUrl}/ask`, { question: symbol });
        setLoading(false);
        printStringByLetter(res.data.answer, "my_chatgpt_style_div_1");
        setShowSuggestions(false); 
    } catch (error) {
      console.error("Error:", error);
      setResponse("Error fetching response");
    }
  };

  const handleButtonClick = async (value) => {
    const symbol = coinData[value];
    setQuestion(value);
    setButtonsDisabled(true); 
    setLoading(true);
    if (!symbol) {
      setLoading(false);
      printStringByLetter("Sorry, this system only allows searches related to cryptocurrencies and tokens.", "my_chatgpt_style_div_1");
      return;
    }

    try {
      const res = await axios.post(`${BaseUrl}/ask`, { question: symbol });
      setLoading(false);
      printStringByLetter(res.data.answer, "my_chatgpt_style_div_1");
      setShowSuggestions(false); 
    } catch (error) {
      console.error("Error:", error);
      setResponse("Error fetching response");
    }
  };

  const handleInputChange = (e) => {
    const { value } = e.target;
    setQuestion(value);

    const filteredSuggestions = Object.keys(coinData).filter(symbol =>
      symbol.toLowerCase().includes(value.toLowerCase())
    );
    setSuggestions(filteredSuggestions);
    setShowSuggestions(true);
  };

  return (
    <div className="wrapper">
      <header className="text-center mt-4 mb-4">
        <div className="row justify-content-center gx-0">
          <div className="col-md-8">
            <img src={logo} width="210" className="mt-3 mb-3" alt="Logo"/>
            <h1><span className="text-special">AI</span>: Unveiling Crypto Secrets</h1>
            <div className="text-center text-muted">Dive into the world of cryptocurrencies with our AI-based
              knowledge system, designed to provide you with in-depth analysis, sentiment tracking, and real-time signals for crypto tokens.</div>
              <form onSubmit={handleSubmit} className='form-container'>
            <div className="input-group mb-3 mt-4 shadowx">
              <input 
                type="text" 
                className="form-control p-3" 
                placeholder="Discover your preferred token"
                value={question}
                onChange={handleInputChange}
                aria-label="Discover your preferred token"
                aria-describedby="basic-addon2"
                style={{border:"none"}}
              />
              <button type="submit"  disabled={buttonsDisabled} style={{border: "none", backgroundColor: "transparent"}}>
                <FontAwesomeIcon icon={faPaperPlane} className="icon" hidden={buttonsDisabled} style={{color:'gray', transform: "rotate(408deg)",paddingLeft:"19px",paddingRight:"23px" }} />
              </button>
            </div>
            </form>
            {showSuggestions && suggestions.length > 0 && (
              <ul className="suggestions-list" hidden={buttonsDisabled}>
                {suggestions.map((suggestion, index) => (
                  <li key={index} onClick={() => handleButtonClick(suggestion)}>{suggestion}</li>
                ))}
              </ul>
            )}
            <div className="text-center">
              <button type="button" className="btn btn-outline-dark btn-tags" onClick={() => handleButtonClick("Bitcoin")} disabled={buttonsDisabled}>Bitcoin</button>
              <button type="button" className="btn btn-outline-dark btn-tags ms-1" onClick={() => handleButtonClick("Ethereum")} disabled={buttonsDisabled}>Ethereum</button>
              <button type="button" className="btn btn-outline-dark btn-tags ms-1" onClick={() => handleButtonClick("Litecoin")} disabled={buttonsDisabled}>Litecoin</button>
              <button type="button" className="btn btn-outline-dark btn-tags ms-1" onClick={() => handleButtonClick("Solana")} disabled={buttonsDisabled}>Solana</button>
            </div>
            {isLoading && (
              <Button variant="primary" style={{ backgroundColor: 'transparent', borderColor: 'transparent' }}>
                <Spinner
                  as="span"
                  animation="grow"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  style={{ marginRight: '5px', color: '#0a9ad9' }}
                />
                <span style={{ color: 'black', fontWeight: 'bold' }}>Fetching Information...</span>
              </Button>
            )}
            
            <div className="response mt-4 answer-text">
              <div
                id="my_chatgpt_style_div_1"
                style={{
                  display: "none",
                  borderRadius: "10px",
                  fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
                  color: "#282A35",
                  textAlign: "left",
                  padding: "10px !important",
                }}
              ></div>
            </div>
          </div>
        </div>
      </header>
      <main className="main container my-5">
        {/* Add your main content here */}
      </main>
      <footer className="footer text-center fixed-bottom">
        <div className="container">
          <span className="text-muted"><small>&copy; {new Date().getFullYear()} Blue Aster all rights reserved.</small></span>
          <button className="btn btn-link" onClick={handleShowModal}>Disclaimer</button> {/* Add disclaimer button */}
        </div>
      </footer>

      {/* Modal for disclaimer */}
      <Modal show={showModal} onHide={handleCloseModal}>
  <Modal.Header closeButton>
    <Modal.Title>Disclaimer for Crypto Secrets by BlueAsterCapital</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <p>
      <strong>Disclaimer:</strong> The information provided by the Crypto Secrets AI chatbot is for informational and educational purposes only. While the chatbot offers insights on crypto signals, market sentiments, and related topics, it is not a substitute for professional financial advice, investment recommendations, or trading strategies.
    </p>
    <ul>
      <li>
        <strong>No Financial Advice:</strong> The content generated by Crypto Secrets does not constitute financial, legal, or investment advice. Always consult a licensed financial advisor or conduct your own research before making any investment decisions.
      </li>
      <li>
        <strong>Market Risks:</strong> Cryptocurrency markets are highly volatile and involve significant risks. Past performance of signals or sentiments is not indicative of future results.
      </li>
      <li>
        <strong>Accuracy of Information:</strong> While we strive to provide accurate and up-to-date information, BlueAsterCapital does not guarantee the accuracy, completeness, or reliability of the data or analyses shared by the chatbot.
      </li>
      <li>
        <strong>User Responsibility:</strong> Users are solely responsible for their decisions based on the information provided by Crypto Secrets. BlueAsterCapital and its affiliates shall not be held liable for any losses or damages resulting from the use of this information.
      </li>
      <li>
        <strong>Regulatory Compliance:</strong> Cryptocurrencies may be subject to legal and regulatory requirements in various jurisdictions. Users should ensure compliance with local laws and regulations before engaging in any cryptocurrency-related activities.
      </li>
    </ul>
    <p>
      By using the Crypto Secrets chatbot, you acknowledge and agree to this disclaimer and assume full responsibility for your actions.
    </p>
    <p>
      For further inquiries, contact BlueAsterCapital at <a href="https://blueastercapital.com" target="_blank" rel="noopener noreferrer">blueastercapital.com</a>.
    </p>
  </Modal.Body>
</Modal>

    </div>
  );
}

export default App;
